module.exports = __webpack_public_path__ + "static/media/14.3c6d49c8.jpg";